import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import RequiredDisabledFieldWrapper from 'App/components/PatientForm/components/CommonPatientFieldWrapper';
import { PhoneField } from 'App/components/PatientForm/components/PhoneField';
import { CheckboxField } from 'Shared/form/CheckboxField';
import { DatePickerField } from 'Shared/form/DatePickerField';
import { NumberField } from 'Shared/form/NumberField';
import SelectField from 'Shared/form/SelectField';
import { TextField } from 'Shared/form/TextField';

const coverageTypeOptions = [
    'Buy and Bill',
    'Cash',
    'Financial Assistance',
    'Foundation Assistance',
    'Medical',
    'None',
    'Pharmacy',
];

const payerSegmentOptions = [
    'Auto Insurance',
    'Charity/Indigent Program',
    'Government',
    'HMO/Commercial',
    'Integrated PBM',
    'Managed Medicaid',
    'Medicaid',
    'Medicare',
    'Medicare A',
    'Medicare Advantage (Part C)',
    'Medicare B',
    'Medicare D',
    'None',
    'Other',
    'PPO/Commercial',
    'Prisoners',
    'Self-Pay',
    'Tri-Care',
    'Unknown',
    'Workers Comp',
];

const yesNoOptions = ['No', 'Yes'];

const InsuranceFormArea = ({ fieldPrefix, isBenefitsInsurance, insuranceId, disabled: disabledOverride }) => {
    return (
        <div>
            <Row>
                <RequiredDisabledFieldWrapper fieldName="planName">
                    {(commonProps) => (
                        <Col md={3}>
                            <TextField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}name`}
                                label="Plan Name"
                                placeholder="Plan Name"
                                required
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
                <RequiredDisabledFieldWrapper fieldName="patientId">
                    {(commonProps) => (
                        <Col md={3}>
                            <TextField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}planPatientId`}
                                label="Patient ID"
                                placeholder="Patient ID"
                                required
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
                <RequiredDisabledFieldWrapper fieldName="benefitCoverageType">
                    {(commonProps) => (
                        <Col md={3}>
                            <SelectField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}coverageType`}
                                label="Benefit Coverage Type"
                                options={coverageTypeOptions.map((o) => ({ label: o, value: o }))}
                                isClearable
                                required
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
                <RequiredDisabledFieldWrapper fieldName="payorType">
                    {(commonProps) => (
                        <Col md={3}>
                            <SelectField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}payerSegment`}
                                label="Payor Type"
                                options={payerSegmentOptions.map((o) => ({ label: o, value: o }))}
                                isClearable
                                required
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
            </Row>

            <Row>
                <RequiredDisabledFieldWrapper fieldName="bin">
                    {(commonProps) => (
                        <Col md={3}>
                            <TextField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}pharmacyInsuranceBin`}
                                label="BIN"
                                placeholder="BIN"
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
                <RequiredDisabledFieldWrapper fieldName="pcn">
                    {(commonProps) => (
                        <Col md={3}>
                            <TextField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}pharmacyInsurancePcn`}
                                label="PCN"
                                placeholder="PCN"
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
                <RequiredDisabledFieldWrapper fieldName="rxGroupNumber">
                    {(commonProps) => (
                        <Col md={3}>
                            <TextField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}pharmacyInsuranceGroupId`}
                                label="RX Group Number"
                                placeholder="RX Group Number"
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
                <RequiredDisabledFieldWrapper fieldName="personCode">
                    {(commonProps) => (
                        <Col md={3}>
                            <TextField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}pharmacyInsurancePersonCode`}
                                label="Person Code"
                                placeholder="Person Code"
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
            </Row>

            <Row>
                <RequiredDisabledFieldWrapper fieldName="highDeductiblePlan">
                    {(commonProps) => (
                        <Col md={3}>
                            <SelectField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}isIntegratedHighDeductable`}
                                label="High Deductible Plan"
                                options={yesNoOptions.map((o) => ({ label: o, value: o }))}
                                isClearable
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
                <RequiredDisabledFieldWrapper fieldName="coverageEffectiveDate">
                    {(commonProps) => (
                        <Col md={3}>
                            <DatePickerField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}coverageEffectiveDate`}
                                label="Coverage Effective Date"
                                placeholder="Coverage Effective Date"
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
                <RequiredDisabledFieldWrapper fieldName="coverageEndDate">
                    {(commonProps) => (
                        <Col md={3}>
                            <DatePickerField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}coverageEndDate`}
                                label="Coverage End Date"
                                placeholder="Coverage End Date"
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
                <RequiredDisabledFieldWrapper fieldName="medicalGroupId">
                    {(commonProps) => (
                        <Col md={3}>
                            <TextField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}groupNumber`}
                                label="Medical Group ID"
                                placeholder="Medical Group ID"
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
            </Row>

            <Row>
                <RequiredDisabledFieldWrapper fieldName="deductibleAmount">
                    {(commonProps) => (
                        <Col md={3}>
                            <NumberField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}deductableAmount`}
                                label="Deductible Amount"
                                placeholder="Deductible Amount"
                                prefixAddon="$"
                                min={0}
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
                <RequiredDisabledFieldWrapper fieldName="deductibleAmountPaidToDate">
                    {(commonProps) => (
                        <Col md={3}>
                            <NumberField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}deductableAmountPaidToDate`}
                                label="Deductible Amount Paid To Date"
                                placeholder="Deductible Amount Paid To Date"
                                prefixAddon="$"
                                min={0}
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
                <RequiredDisabledFieldWrapper fieldName="outOfPocketMaximum">
                    {(commonProps) => (
                        <Col md={3}>
                            <NumberField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}pharmacyPlanOopMax`}
                                label="Out Of Pocket Maximum"
                                placeholder="Out Of Pocket Maximum"
                                prefixAddon="$"
                                min={0}
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
                <RequiredDisabledFieldWrapper fieldName="outOfPocketMaximumPaidToDate">
                    {(commonProps) => (
                        <Col md={3}>
                            <NumberField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}pharmacyPlanOopMaxPaidToDate`}
                                label="Out Of Pocket Maximum Paid To Date"
                                placeholder="Out Of Pocket Maximum Paid To Date"
                                prefixAddon="$"
                                min={0}
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
            </Row>

            <Row>
                <RequiredDisabledFieldWrapper fieldName="coverageCarveOut">
                    {(commonProps) => (
                        <Col md={3}>
                            <SelectField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}isPharmacyBenefitsCarveOutFromMedical`}
                                label="Coverage Carve-Out"
                                options={yesNoOptions.map((o) => ({ label: o, value: o }))}
                                isClearable
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
                <RequiredDisabledFieldWrapper fieldName="helpDeskPhone">
                    {(commonProps) => (
                        <Col md={3}>
                            <PhoneField
                                {...commonProps}
                                disabled={commonProps.disabled || disabledOverride}
                                fieldName={`${fieldPrefix}helpDeskPhone`}
                                label="Help Desk Phone"
                            />
                        </Col>
                    )}
                </RequiredDisabledFieldWrapper>
            </Row>

            {insuranceId && !isBenefitsInsurance && (
                <CheckboxField fieldName={`${fieldPrefix}disableInsurancePlan`} label="Disable Insurance Plan" />
            )}
        </div>
    );
};

InsuranceFormArea.propTypes = {
    fieldPrefix: PropTypes.string.isRequired,
    isBenefitsInsurance: PropTypes.bool,
    insuranceId: PropTypes.number,
    disabled: PropTypes.bool,
};

InsuranceFormArea.defaultProps = {
    isBenefitsInsurance: false,
    insuranceId: null,
    disabled: false,
};

export default InsuranceFormArea;
